import { useEffect, useMemo, useState } from "react"

import appStore from '@Stores/app'

/**
 * @template  {string} T
 * @param  {T} siteKey
 */

export default function hookSiteSelectedFactory(siteKey) {
  return () => {
    const seletedSiteId = appStore.site?.id
    const [siteId, setSiteId] = useState(seletedSiteId || null)

    useEffect(() => {
      setSiteId(seletedSiteId || null)
    }, [seletedSiteId])

    return useMemo(() => ({
      siteSelected: {
        id: siteId,
        key: siteKey,
      },
    }), [siteId])
  }
}
